import { Injectable } from "@angular/core";
import * as moment from "moment";
import { HttpClient } from "@angular/common/http";

//interfaces
import { OrderItemInterface, OrderPreviewItemInterface, TransactionInterface } from "../interfaces";

//services
import { OrderService } from "../services";
import { OrderHelper } from "./order.helper";

@Injectable({
    providedIn: 'root'
})
export class PrinterHelper {

    private issueID = 1;
    private imageBase64: string | null = null;

    constructor(
        private http: HttpClient,
        private orderHelper: OrderHelper
    ) { }

    async printReceipt(transaction: TransactionInterface) {
        try {
            const res = this.orderHelper.calculateSum();
            await this.loadImage();
            console.log('base', this.imageBase64)
            moment.locale('de-ch');
            setPosId(this.issueID);
            const test = checkPrinterStatus();
            const order = OrderService.orderPreview.getValue().order!;
            printBitmap(this.imageBase64!, -2, 1, false);
            printText("\n\nVolg Personalladen,\nDeltastrasse 2\n8408 Winterthur\n+41 058 433 56 50\n\n\n", 0, 0, false, false, false, 0, 1);
            printText("Artikel                          Betrag M \n", 0, 0, true, false, false, 0, 0);
            order.itemList.forEach(element => {
                if (element.article)
                    printText(this.getReceiptLine(element), 0, 0, false, false, false, 0, 0);
            });
            printText("------------------------------------------\n", 0, 0, false, false, false, 0, 0);
            printText("Subtotal CHF                    " + this.getPriceStr(res.subtotal.toFixed(2), ' ', ' ') + "\n", 0, 0, false, false, false, 0, 0);
            if (order.discounts && order.discounts.length > 0) {
                printText("MA Rabatt Personalladen\n", 0, 0, true, false, false, 0, 0);
                printText(this.getStr("   Rabatt ", 32, false) + this.getPriceStr(order.discounts![0].discount.value.toFixed(2), ' ', ' ') + "\n", 0, 0, true, false, false, 0, 0);
            }
            console.log(res);
            if (res.saved > res.employee && (((res.saved - res.employee) * -1).toFixed(2) !== '-0.00')) {
                printText("Andere Rabatte\n", 0, 0, true, false, false, 0, 0);
                printText(this.getStr("   Rabatt ", 32, false) + this.getPriceStr(((res.saved - res.employee) * -1).toFixed(2), ' ', ' ') + "\n", 0, 0, true, false, false, 0, 0);
            }
            printText("------------------------------------------\n", 0, 0, false, false, false, 0, 0);
            printText("Total CHF                       " + this.getPriceStr(order.total.toFixed(2), ' ', ' ') + "\n", 0, 1, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText("Erhalten:                                 \n", 0, 0, false, false, false, 0, 0);
            printText(transaction.receipt.payment_method + "\n", 0, 0, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText("Buchung                                   \n", 0, 0, false, false, false, 0, 0);
            printText(transaction.receipt.detailled_payment_method + "\n", 0, 0, false, false, false, 0, 0);
            if (transaction.receipt.payment_method !== 'TWINT')
                printText(transaction.receipt.card_number + "     \n", 0, 0, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText(moment().format('L') + "                        " + moment().format('LTS') + '\n', 0, 0, false, false, false, 0, 0);
            if (transaction.receipt.kasse_nr !== -1) {
                printText("Trm-Id:               " + this.getStr(transaction.receipt.trm_id, 20, true) + "\n", 0, 0, false, false, false, 0, 0);
                printText("Akt-Id:               " + this.getStr(transaction.receipt.akt_id, 20, true) + "\n", 0, 0, false, false, false, 0, 0);
                printText("AID:                  " + this.getStr(transaction.receipt.aid, 20, true) + "\n", 0, 0, false, false, false, 0, 0);
                printText("Trx. Seq-Cnt:         " + this.getStr(transaction.receipt.trx_seq_cnt, 20, true) + "\n", 0, 0, false, false, false, 0, 0);
                printText("Trx. Ref-No:          " + this.getStr(transaction.receipt.trx_ref_nr, 20, true) + "\n", 0, 0, false, false, false, 0, 0);
                printText("Auth. Code:           " + this.getStr(transaction.receipt.code, 20, true) + "\n", 0, 0, false, false, false, 0, 0);
                printText("Acq-Id:               " + this.getStr(transaction.receipt.acq_id, 20, true) + "\n", 0, 0, false, false, false, 0, 0);
                printText(transaction.receipt.lastline_1 + "\n", 0, 0, false, false, false, 0, 1);
                printText(transaction.receipt.lastline_2 + "\n", 0, 0, false, false, false, 0, 0);
                printText(transaction.receipt.lastline_3 + "\n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("Total-EFT CHF:                  " + this.getPriceStr(order.total.toFixed(2), ' ', ' ') + "\n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("WALLEE\n", 0, 0, false, false, false, 0, 1);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("------------------------------------------\n", 0, 0, false, false, false, 0, 0);
                printText("MWST%         Netto      MWST    Brutto M \n", 0, 0, false, false, false, 0, 0);
                order.transactionVats!.vatCodes.forEach(element => {
                    printText(element.vatPercent.toFixed(2) + "      " + this.getStr(String(element.netAmount.toFixed(2)), 9, true) + this.getStr(String(element.vatAmount.toFixed(2)), 10, true) + this.getStr(String(element.grossAmount.toFixed(2)), 10, true) + " " + (element.vatId == 2 ? 'B' : 'C') + " \n", 0, 0, false, false, false, 0, 0);
                });

                printText("Total MWST" + this.getStr((order.total - order.transactionVats!.vatTotal).toFixed(2).toString(), 9, true) + this.getStr(order.transactionVats!.vatTotal.toFixed(2).toString(), 10, true) + this.getStr(order.total.toFixed(2).toString(), 10, true) + "   \n", 0, 0, false, false, false, 0, 0);
            } else {
                printText("Simulierte Zahlungen koennen diesen \nAbschnitt nicht anzeigen\n", 0, 0, false, false, false, 0, 0);
                printText("Akt-Id:               ------\n", 0, 0, false, false, false, 0, 0);
                printText("AID:                  ------\n", 0, 0, false, false, false, 0, 0);
                printText("Trx. Seq-Cnt:         ------\n", 0, 0, false, false, false, 0, 0);
                printText("Trx. Ref-No:          ------\n", 0, 0, false, false, false, 0, 0);
                printText("Auth. Code:           ------\n", 0, 0, false, false, false, 0, 0);
                printText("Acq-Id:               ------\n", 0, 0, false, false, false, 0, 0);
                printText("--------\n", 0, 0, false, false, false, 0, 1);
                printText("--------\n", 0, 0, false, false, false, 0, 0);
                printText("--------\n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("Total-EFT CHF:                  " + this.getPriceStr(order.total.toFixed(2), ' ', ' ') + "\n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("WALLEE\n", 0, 0, false, false, false, 0, 1);
                printText("                                          \n", 0, 0, false, false, false, 0, 0);
                printText("------------------------------------------\n", 0, 0, false, false, false, 0, 0);
                printText("MWST%         Netto      MWST    Brutto M \n", 0, 0, false, false, false, 0, 0);

            }
            printText("------------------------------------------\n", 0, 0, false, false, false, 0, 0);
            printText("CHE-105.854.145 MWST                      \n", 0, 0, false, false, false, 0, 0);
            printText("------------------------------------------\n", 0, 0, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText("* nicht rabattberechtigt                  \n", 0, 0, false, false, false, 0, 0);
            printText("# Rabatt nicht kumulierbar                \n", 0, 0, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText("Es bedient Sie:                           \n", 0, 0, false, false, false, 0, 0);
            printText("Selbstbedienungskasse                     \n", 0, 0, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText("Besten Dank fuer Ihren Einkauf            \n", 0, 0, false, false, false, 0, 0);
            printText("                                          \n", 0, 0, false, false, false, 0, 0);
            printText("Bon: " + this.getStr(transaction.receipt.bon_nr, 10, false) + "           " + moment().format('L') + ' ' + moment().format('LT') + '\n', 0, 0, false, false, false, 0, 0);
            printText("Kasse: " + OrderService.shopCode.value + "0" + transaction.receipt.kasse_nr + "                Shop: " + OrderService.shopCode.value + "\n", 0, 0, false, false, false, 0, 0);

            printText("\n\n\n\n\n", 0, 0, false, false, false, 0, 1);
            cutPaper(1);

            var strSubmit = getPosData();

            this.issueID++;
            requestPrint('Printer1', strSubmit, this.viewResult);
        } catch (error) {
            console.error('Error in printReceipt', error);
        }

        /* printText("                                          \n\n", 0, 0, false, false, false, 0, 0);
        print1DBarcode("6664232300425622", 5, 4, 120, 2, 1); */
    }

    private viewResult(string: string) {
        console.log('result: ' + string)
    }

    private getReceiptLine(orderItem: OrderPreviewItemInterface) {
        let str = '';
        str += orderItem.article.description;
        if (orderItem.quantity > 1) str += ' x' + orderItem.quantity;
        str = str.replaceAll('Ü', 'UE');
        str = str.replaceAll('Ö', 'OE');
        str = str.replaceAll('Ä', 'AE');
        while (str.length < 32) {
            str += ' ';
        }
        let priceStr = this.getPriceStr(Number(orderItem.article.baseUnitPrice).toFixed(2), (orderItem.vatId == 2 ? 'B' : 'C'), ' ');
        return str + priceStr + "\n";
    }

    private getPriceStr(price: string, letter: string, star: string) {
        let priceStr = '';
        priceStr += price;
        priceStr += ' ' + letter + star;
        while (priceStr.length < 10) {
            priceStr = ' ' + priceStr;
        }
        return priceStr
    }
    private getStr(value: string | null, width: number, rightAlligned: boolean) {
        let tmpStr = value || 'N/A';
        while (tmpStr.length < width) {
            tmpStr = rightAlligned ? (' ' + tmpStr) : (tmpStr + ' ');
        }
        return tmpStr
    }


    private loadImage(): Promise<void> {
        return new Promise((resolve, reject) => {
            this.http.get('/assets/images/volg-logo.bmp', { responseType: 'blob' }).subscribe(
                (blob: Blob) => {
                    this.convertBlobToBase64(blob)
                        .then(() => resolve())
                        .catch(error => reject(error));
                },
                (error) => {
                    console.error('Error loading image', error);
                    reject(error);
                }
            );
        });
    }

    private convertBlobToBase64(blob: Blob): Promise<void> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.imageBase64 = reader.result as string;
                resolve();
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

}